import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommerceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Commerce",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M28.43 15.29c-.63 0-1.14-.51-1.14-1.14v-2.29c0-.63-.51-1.14-1.14-1.14H5.57a1.14 1.14 0 1 1 0-2.28h20.57c1.89 0 3.43 1.54 3.43 3.43v2.29c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.14 29H5.57c-3.15 0-5.71-2.56-5.71-5.71V9.58c0-3.16 2.56-5.72 5.71-5.72h18.29a1.14 1.14 0 1 1 0 2.28H5.57c-1.89 0-3.43 1.54-3.43 3.43v13.71c0 1.89 1.54 3.43 3.43 3.43h20.57c.63 0 1.14-.51 1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0v3.43c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.71 23.29h-9.14c-1.89 0-3.43-1.54-3.43-3.43v-2.29c0-1.89 1.54-3.43 3.43-3.43h9.14c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14Zm-9.14-6.86c-.63 0-1.14.51-1.14 1.14v2.29c0 .63.51 1.14 1.14 1.14h8v-4.57z"
    })]
  }));
};
CommerceIcon.displayName = 'CommerceIcon';